import { Link } from 'react-router-dom';
import { categories } from '@/mocks/skincare';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            探索护肤分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按主题浏览，找到你最关心的护肤话题
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2 whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 mt-4 text-sm text-primary-500 font-medium whitespace-nowrap">
                浏览文章
                <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}